export default __webpack_public_path__ + "./image/894399050f94c63a5aaaa095fb15eac4.png";